<template>
  <div class="list-select-input">
    <template v-for="list in field.value">
      <div class="row">
        <div class="col-sm-8 offset-sm-4">
          <div class="panel panel-default">
            <div class="panel-heading">
              <div class="row">
                <div class="col-xs-10">
                  <h1 class="panel-title">{{ $key }}</h1>
                </div>
                <div class="col-xs-2 text-right">
                  <button v-if="selected.length > 0 && selectedList != $key" @click.prevent="moveValues($key)" class="btn btn-info btn-xs"><span class="fa fa-arrows-alt fa-fw"></span> Move</button>
                </div>
              </div>
            </div>
            <div class="panel-body">
              <select class="form-control" multiple="multiple" v-on:change="changeFocus($event, $key)">
              <template v-for="object in list">
                <option v-bind:value="object.uuid">{{ object.dropdownLabel }}</option>
              </template>
              <option v-if="list.length == 0" disabled>Empty</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="col-sm-8 offset-sm-4">
      <button v-if="!addList" @click.prevent="addList = true" class="btn btn-success"><span class="fa fa-plus fa-fw"></span> Add</button>
    </div>
    <template v-if="addList">
      <text-input :field.sync="newList"></text-input>
      <div class="col-sm-8 offset-sm-4">
        <button v-if="newList.value" @click.prevent="addNewList()" class="btn btn-warning"><span class="fa fa-plus fa-fw"></span> Add</button>
      </div>
    </template>
  </div>
</template>

<script>
import TextInput from './TextInput.vue'
import Vue from 'vue'
export default {
  name: 'ListSelectInput',
  components: {
    TextInput
  },
  props: {
    field: {
      type: Object,
      default () {
        return {
          name: 'lists',
          type: 'listSelect',
          label: '',
          value: {},
          objects: [],
          confirmation: false,
          valid: true,
          dirty: false
        }
      }
    }
  },
  data () {
    return {
      selected: [],
      focusedSelect: false,
      selectedList: '',
      addList: false,
      newList: {
        name: 'newList',
        type: 'text',
        label: 'New List Name',
        value: '',
        confirmation: false,
        valid: true,
        dirty: false
      }
    }
  },
  methods: {
    addNewList () {
      Vue.set(this.field.value, this.newList.value, [])
      this.newList.value = ''
      this.addList = false
    },
    changeFocus (event, key) {
      let currentFocus = this.focusedSelect
      if (currentFocus && currentFocus !== event.target) {
        currentFocus.selectedIndex = -1
      }
      this.focusedSelect = event.target
      this.selected = event.target.selectedOptions
      this.selectedList = key
    },
    moveValues (list) {
      for (let option of this.selected) {
        this.field.value[this.selectedList].forEach(el => {
          if (el.uuid === option.value) {
            this.field.value[list].push(el)
            this.field.value[this.selectedList].$remove(el)
          }
        })
      }
      this.selected = []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/ListSelectInput.vue